import { Form, Spin } from 'antd';
import {
  deletePartner,
  getDetailPartner,
  updateDetailPartner,
} from 'api/partner/partner.api';
import { ButtonNavigate } from 'components/Button';
import { Container, FormWrapper } from 'components/Form/Template/styled';
import Breadcrumb from 'components/Layout/ApplicationLayout/Breadcrumb';
import LayoutDefault from 'components/Layout/LayoutDefault';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useModalConfirm from 'hook/useModalConfirm';
import useCustomMutate from 'hook/useQuery/useCustomMutate';
import useCustomMutateRenderMessage from 'hook/useQuery/useCustomMutateRenderMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import useSetTitlePage from 'hook/useSetTitlePage';
import useMultiLanguageAccountSolitonList from 'page/Application/ManageAccountSoliton/AccountSolitonList/hook/useMultiLanguageManageAccountSolitonList';
import {
  FormPermission,
  FormTitle,
} from 'page/Application/ManageCompanyList/component/Form';
import FormPartner from 'page/Application/ManageCompanyList/component/FormPartner';
import useMultiLanguageEditCompany from 'page/Application/ManageCompanyList/EditCompany/hook/useMultiLanguageEditCompany';
import useErrorCodeManageCompany from 'page/Application/ManageCompanyList/hook/useErrorCodeManageCompany';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { partnerIdRecoil, userInformation } from 'recoil/atom/authentication';
import { idProduct, listProduct, product } from 'recoil/atom/selectProduct';

const checkSpace = /\s/g;

const EditCompany = () => {
  const location = useLocation();
  const { searchKeywordState, filterDataState } = location.state || {};
  // recoil
  const [listSelectedProduct, setListSelectedProduct] =
    useRecoilState(listProduct);
  const [, setProductSelected] = useRecoilState(product);
  const [, setIdProductSelected] = useRecoilState(idProduct);

  const [, setPartnerId] = useRecoilState(partnerIdRecoil);
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();
  // useState
  const [listPermissionUser, setListPermissionUser] = useState([]);
  const [dataDate, setDataDate] = useState({});
  const [isDisable, setIsDisable] = useState(false);
  const [isAvailable, setIsAvailable] = useState(true);
  const [isDomainAvailable, setIsDomainAvailable] = useState(true);

  // hook
  const navigate = useNavigate();
  const { partnerId } = useParams();
  const [form] = Form.useForm();
  const { role } = useRecoilValue(userInformation);
  const isSolitonUser = role === 'ROLE_SOLITON_USER';

  // custom hook
  const { handleConfirmAction, contextHolder } = useModalConfirm();
  const { ERROR_CODE_MANAGE_COMPANY } = useErrorCodeManageCompany();
  const { ACCOUNT_LIST_DELETE_SUCCESS } = useMultiLanguageAccountSolitonList();
  const { useQueryAPI } = useCustomQuery();
  const { useMutationAPI } = useCustomMutate();
  const { useMutationAPIHandleErrorCode, errorMessage } =
    useCustomMutateRenderMessage({ errorCode: ERROR_CODE_MANAGE_COMPANY });
  const {
    DETAIL_COMPANY_TITLE,
    DETAIL_COMPANY_MESSAGE_SUCCESS,
    DETAIL_COMPANY_CONFIRM_CANCEL,
    DETAIL_COMPANY_CONFIRM_SAVE,
    DETAIL_COMPANY_CONFIRM_DELETE,
  } = useMultiLanguageEditCompany();

  // breadcrumb item
  const listItemSA = useMemo(() => {
    return [
      {
        title: (
          <Link
            to={'/manage-company-list'}
            state={{
              searchKeywordState: searchKeywordState,
              filterDataState: filterDataState,
            }}
          >
            企業管理
          </Link>
        ),
      },
      {
        title: '企業詳細',
      },
    ];
  }, []);

  const listItemSU = useMemo(() => {
    return [
      {
        title: <Link to={'/my-page'}>マイページ</Link>,
      },
      {
        title: (
          <Link
            to={'/manage-company-list'}
            state={{
              searchKeywordState: searchKeywordState,
              filterDataState: filterDataState,
            }}
          >
            企業管理
          </Link>
        ),
      },
      {
        title: '企業詳細',
      },
    ];
  }, []);

  const listItemByRole = useMemo(() => {
    return {
      ROLE_SOLITON_ADMIN: listItemSA,
      ROLE_SOLITON_USER: listItemSU,
    };
  }, [listItemSA, listItemSU]);

  // call API fetch data partner detail
  const {
    data: partnerDetail,
    isLoading,
    error,
  } = useQueryAPI({
    api: getDetailPartner,
    params: {
      partnerId: partnerId,
    },
    key: 'partnerDetail',
    enabled: !!partnerId,
    options: {
      refetchOnWindowFocus: false, // cancel fetch data when out focus
      cacheTime: 0,
    },
  });

  // call API delete partner
  const { mutate: deletePartnerMutate } = useMutationAPI({
    api: deletePartner,
    refetchKey: 'companyList',
    path: '/manage-company-list',
    state: {
      searchKeywordState: searchKeywordState,
      filterDataState: filterDataState,
    },
    messageSuccess: `${partnerDetail?.data?.partnerName} ${ACCOUNT_LIST_DELETE_SUCCESS}`,
  });

  // call API update partner
  const {
    mutate: updatePartnerMutate,
    isError,
    isLoading: isLoadingSubmit,
    isSuccess,
  } = useMutationAPIHandleErrorCode({
    api: updateDetailPartner,
    refetchKey: 'companyList',
    messageSuccess: DETAIL_COMPANY_MESSAGE_SUCCESS,
    path: '/manage-company-list',
    state: {
      searchKeywordState: searchKeywordState,
      filterDataState: filterDataState,
    },
  });
  // move to screen company list

  // confirm cancel, back and navigate to list partner
  const handleCancel = () => {
    if (isOnline) {
      handleConfirmAction({
        confirmFn: navigate,
        params: '/manage-company-list',
        title: DETAIL_COMPANY_CONFIRM_CANCEL,
        setIsDisable: setIsDisable,
        state: {
          searchKeywordState: searchKeywordState,
          filterDataState: filterDataState,
        },
      });
      setIsDisable(true);
    } else {
      errorNetWork();
    }
  };

  // navigate to page partner
  const handleNavigate = () => {
    if (isOnline) {
      setPartnerId({
        partnerId: partnerId,
      });
      navigate(`/partner-page/${partnerId}`, {
        state: {
          partnerId: partnerId,
          searchKeywordState: searchKeywordState,
          filterDataState: filterDataState,
        },
      });
    } else {
      errorNetWork();
    }
  };

  // check list email empty or undefined => return []
  const checkEmailValid = (emailList) => {
    if (emailList[0] !== '') {
      return emailList.filter((item) => item !== undefined && item !== '');
    } else return [];
  };

  // format data, open modal confirm, pass function mutate, params for call API update
  const handleUpdatePartner = () => {
    if (isOnline) {
      form
        .validateFields()
        .then(() => {
          // get all value from form instance
          const value = form.getFieldsValue();

          // format data, return new array object
          let listUser = [];
          if (listPermissionUser?.length > 0) {
            listUser = listPermissionUser?.map((item) => ({
              userId: item?.userId,
              status: item?.approveStatus,
            }));
          }

          // format data, return new array object, handle value isAutoApprove === true | false
          let domain = [];
          if (value?.domainList?.length > 0) {
            domain = value?.domainList
              ?.filter(
                (item) =>
                  item?.domainName !== undefined && item?.domainName !== '',
              )
              ?.map((item) => ({
                domainId: item?.domainId,
                domainName: item?.domainName?.replace(checkSpace, ''),
                isAutoApprove:
                  item?.isAutoApprove === '' ||
                  item?.isAutoApprove === undefined
                    ? false
                    : item?.isAutoApprove,
              }));
          }
          const checkEmailList = checkEmailValid(value.partnerEmail ?? []);
          const emailListReplaceSpace = checkEmailList?.map((item) => {
            return item.replace(checkSpace, '');
          });

          // merge data, from form, list domain, list product, list user permission to payload
          const payload = {
            partnerRequest: {
              saleForceId: value?.saleForceId ? value?.saleForceId : undefined,
              partnerName: value?.partnerName,
              partnerEmail: emailListReplaceSpace,
              solitonEmail: value?.solitonEmail?.replace(checkSpace, ''),
              note: value?.note?.trim(),
              partnerType: value?.partnerType,
            },
            domainRequests: domain,
            listProduct: listSelectedProduct?.listRecordProduct?.map(
              (item) => ({
                productId: item?.productId ?? item?.id, // because response of api GET ListProduct is id, but response api getDetailPartner and updateDetailPartner is productId
                type: item?.type,
                productName: item?.productName,
              }),
            ),
            approvalRequests: listUser,
          };

          // open modal confirm, pass function call api update partner & payload
          handleConfirmAction({
            confirmFn: updatePartnerMutate,
            params: { partnerId: partnerId, payload: payload },
            title: DETAIL_COMPANY_CONFIRM_SAVE,
            setIsDisable: setIsDisable,
          });
          setIsDisable(true);
        })
        .catch(() => {
          return false;
        });
    } else {
      errorNetWork();
    }
  };

  // open modal confirm, pass function call api delete partner & payload
  const handleDeletePartner = () => {
    if (isOnline) {
      handleConfirmAction({
        confirmFn: deletePartnerMutate,
        params: partnerId,
        title: DETAIL_COMPANY_CONFIRM_DELETE,
        setIsDisable: setIsDisable,
      });
      setIsDisable(true);
    } else {
      errorNetWork();
    }
  };

  // set data from api to form
  useEffect(() => {
    if (error?.response?.data?.message === '404_PARTNER_NOT_FOUND') {
      navigate('/partner-not-found');
    }
    if (partnerDetail && partnerDetail.ec === false && partnerDetail.data) {
      const {
        lstDomainResponses,
        lstProductResponses,
        lstUserResponses,
        partnerEmail,
        partnerName,
        solitonEmail,
        saleForceId,
        note,
        partnerType,
      } = partnerDetail?.data;

      setIsAvailable(!partnerEmail?.length > 0);
      setIsDomainAvailable(!lstDomainResponses?.length > 0);
      setDataDate({
        createdTime: partnerDetail?.data?.createdTime,
        updatedTime: partnerDetail?.data?.updatedTime,
      });

      form.setFieldsValue({
        saleForceId: saleForceId,
        partnerEmail: partnerEmail?.length > 0 ? partnerEmail : [''],
        partnerName: partnerName,
        solitonEmail: solitonEmail,
        note: note,
        partnerType: partnerType,
        domainList:
          lstDomainResponses?.length > 0
            ? lstDomainResponses
            : [{ name: '', isAutoApprove: '' }], // change value from [] to [{name: '', isAutoApprove: ''},] for render form
      });
      if (lstProductResponses?.length > 0) {
        const listId = lstProductResponses?.map((item) => item?.productId);
        const listProduct = lstProductResponses?.map((item) => ({
          // format list product for render table
          ...item,
          key: item?.productId,
        }));
        setListSelectedProduct({
          listIdProduct: listId,
          listRecordProduct: listProduct,
        });
        setProductSelected(listProduct);
        setIdProductSelected(listId);
      } else {
        setProductSelected([]);
        setIdProductSelected([]);
      }
      setListPermissionUser(lstUserResponses);
    }
  }, [
    error?.response?.data?.message,
    form,
    navigate,
    partnerDetail,
    setIdProductSelected,
    setListSelectedProduct,
    setProductSelected,
  ]);

  useSetTitlePage(
    `企業詳細 (${partnerDetail?.data?.partnerName}) | 企業管理 | Soliton パートナーサイト`,
    !!partnerDetail?.data?.partnerName,
  );

  return (
    <>
      {contextHolder}
      {contextErrorNetWork}
      <Breadcrumb listItem={listItemByRole[role]} titlePage="企業詳細">
        {!isSolitonUser && (
          <ButtonNavigate text={'パートナーページ'} onClick={handleNavigate} />
        )}
      </Breadcrumb>

      <LayoutDefault>
        <Suspense fallback={isLoading}>
          <Spin spinning={isLoading || isLoadingSubmit || isSuccess}>
            <FormTitle
              notice={!isSolitonUser && '注意：'}
              title={!isSolitonUser && DETAIL_COMPANY_TITLE}
              type={'text'}
              styles={{ color: '#9D1C49' }}
              dataDate={dataDate}
            />

            <FormWrapper>
              <Container>
                <Form
                  form={form}
                  layout="horizontal"
                  size="large"
                  disabled={isSolitonUser}
                >
                  <FormPartner
                    formPartnerName={'partnerName'}
                    onCancel={handleCancel}
                    onFinish={handleUpdatePartner}
                    onDelete={handleDeletePartner}
                    isDelete={true}
                    isDisable={isDisable || isSolitonUser}
                    isSolitonUser={isSolitonUser}
                    setIsDisable={setIsDisable}
                    isError={isError}
                    errorMessage={errorMessage}
                    form={form}
                    setIsAvailable={setIsAvailable}
                    isAvailable={isAvailable}
                    setIsDomainAvailable={setIsDomainAvailable}
                    isDomainAvailable={isDomainAvailable}
                    searchKeywordState={searchKeywordState}
                    filterDataState={filterDataState}
                  >
                    <FormPermission
                      height={'fit-content'}
                      isLoading={isLoading}
                      dataRaw={listPermissionUser}
                      setListPermissionUser={setListPermissionUser}
                    />
                  </FormPartner>
                </Form>
              </Container>
            </FormWrapper>
          </Spin>
        </Suspense>
      </LayoutDefault>
    </>
  );
};

export default EditCompany;
